'use client';

import { createContext, useContext, type ReactNode } from 'react';

interface PresentationModeContextType {
  isPresentationMode: boolean;
}

const PresentationModeContext = createContext<PresentationModeContextType>({
  isPresentationMode: false,
});

/**
 * Hook to check if the app is in presentation/preview mode.
 * In presentation mode, certain actions like checkout submission are disabled.
 */
export function usePresentationMode(): PresentationModeContextType {
  return useContext(PresentationModeContext);
}

interface PresentationModeProviderProps {
  children: ReactNode;
  enabled?: boolean;
}

/**
 * Provider that enables presentation mode for the RED Experience.
 * When enabled, the experience is read-only up to the Checkout step.
 * The Continue button at Checkout is disabled to prevent proceeding to payment.
 */
export function PresentationModeProvider({
  children,
  enabled = false,
}: PresentationModeProviderProps) {
  return (
    <PresentationModeContext.Provider value={{ isPresentationMode: enabled }}>
      {children}
    </PresentationModeContext.Provider>
  );
}
